<template>
  <section class="editUser">
    <resizable-page ref="resPage">
      <template v-slot:header>
        <ValidationObserver
          ref="observer"
          v-slot="{ invalid }"
          tag="section"
          class="editUsers_actions"
        >
          <section>
            <section class="editUsers_input-header">
              <span class="editUsers_name">ID（メールアドレス）</span>
              <span class="editUsers_note">必須</span>
            </section>
            <ValidationProvider
              v-slot="{ errors }"
              vid="email"
              name="メールアドレス"
              rules="required|email"
            >
              <v-text-field
                v-model="email"
                height="40px"
                color="dark"
                class="editUsers_input-name editUsers_input-email"
                required
                persistent-hint
                dense
                :error-messages="errors"
                :maxlength="80"
                outlined
                hint="記入例：sshights.taro@sshights.co.jp"
              />
            </ValidationProvider>
          </section>

          <v-btn
            :disabled="invalid || !isSelectValid"
            :loading="submitLoading"
            class="editUsers_submit"
            @click="handleSubmit"
          >
            招待メールを送信する</v-btn
          >
        </ValidationObserver>
        <h5 class="editUsers_title">カメラグループを登録する</h5>
      </template>
      <template v-slot:table="tableProps">
        <v-skeleton-loader
          v-if="loading || routeLoading"
          :loading="loading || routeLoading"
          type="table"
        ></v-skeleton-loader>

        <v-data-table
          v-else
          class="editUsers_tbl"
          :height="tableProps.bodyHeight"
          :headers="computedHeaders"
          :items="mappedTableItems"
          hide-default-footer
          disable-pagination
          sort-by="dateTime"
          :fixed-header="true"
        >
          <!-- Table header neme template  -->
          <template #[`header.name`]="{ header }">
            <section class="editUsers_tbl-header--name">
              <app-check
                v-if="isEdit"
                v-model="allSelected"
                :disabled="mappedTableItems.length === 0"
                class="editUsers_select-all"
                @input="handleSelectAll"
              >
                <span class="editUsers_select-all-text">{{
                  header.text.toUpperCase()
                }}</span>
              </app-check>
            </section>
          </template>

          <!-- Table body template  -->
          <template v-slot:item="{ item }">
            <tr>
              <td class="text-start">
                <tooltip>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      class="editUsers_tbl-name text-truncate"
                      style="max-width: 100%"
                      v-on="on"
                    >
                      <app-check
                        v-if="isEdit"
                        v-model="selectedCams[item.id]"
                        @input="handleSelect($event, item.id)"
                      >
                        <span class="editUsers_item-name">{{ item.name }}</span>
                      </app-check>
                    </div>
                  </template>
                  <h2>{{ item.name }}</h2>
                </tooltip>
              </td>

              <td class="text-start">
                <section class="editUsers_check">
                  <v-select
                    v-model="camSelectValue[item.id]"
                    :disabled="!selectedCams[item.id]"
                    hide-details
                    :items="authorityItems"
                    item-value="value"
                    item-text="text"
                    outlined
                    flat
                    append-icon="mdi-chevron-down"
                  ></v-select>
                </section>
              </td>
            </tr>
          </template>
          <!-- ----------------- -->
          <!-- Table no data -->
          <template v-slot:no-data>
            <tr style="visibility: hidden" />
          </template>
          <!-- ----------------- -->
        </v-data-table>
      </template>
    </resizable-page>
  </section>
</template>

<script>
import { AllCamerasIdGroup } from '@/globals/constants';
import { MimeTypes } from '@/globals/enums';
import { mapActions, mapGetters, mapState } from 'vuex';
export default {
  name: 'EditUser',
  props: {
    routeLoading: {
      type: Boolean,
      default: false,
    },
    submitLoading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selectedCams: {},
    allSelected: false,
    oldSelectedCams: {},
    showVideo: true,
    email: null,
    mimeTypes: MimeTypes,
    selectedItems: [],
    clipToolsOpen: false,
    loading: false,
    displayCam: false,
    selectMode: false,
    isEdit: true,
    camSelectValue: {},
  }),
  computed: {
    ...mapGetters('common', {
      isPRD: 'isPRD',
    }),
    ...mapState({
      groupCams: (state) => state.settings.groupCams,
    }),
    mappedTableItems() {
      return this.mapRows(this.tableItems);
    },
    authorityItems() {
      let items = [{ value: 1, text: 'カメラの操作可能', canOperate: true }];
      if (!this.isPRD) {
        items = [
          { value: 0, text: 'LIVE映像のみ閲覧可能', canOperate: false },
          ...items,
        ];
      }
      return items.sort((a, b) => b.value - a.value);
    },
    id() {
      return this.$route.params.id;
    },
    isSelectValid() {
      return Object.values(this.selectedCams).some((sc) => sc);
    },
    computedHeaders() {
      const headers = [
        {
          text: '一括選択',
          align: 'start',
          sortable: false,
          value: 'name',
          width: '130',
          class: 'editUsers_header-name',
        },
      ];

      headers.push({
        text: '権限',
        align: 'start',
        sortable: false,
        value: 'authority',
        width: '150',
      });
      return headers;
    },
    filteredItems() {
      return this.query && this.query !== ''
        ? this.groupCams.filter((c) => {
            return c.title.toLowerCase().includes(this.query.toLowerCase());
          })
        : this.groupCams;
    },
    tableItems() {
      return this.filteredItems.map((c) => {
        const item = {
          id: c.id,
          name: c.title,
          authority: null,
        };

        return item;
      });
    },
  },
  watch: {
    groupCams: {
      handler: function (val) {
        const currentGroup = val.find(
          (group) => String(group.id) === String(this.id)
        );
        if (currentGroup) {
          let selectedCams = {};
          currentGroup.details.forEach((cam) => {
            selectedCams = { ...selectedCams, [cam.id]: true };
          });
          this.selectedCams = selectedCams;
          this.oldSelectedCams = { ...this.selectedCams };
          this.checkAllSelected();
        }
      },
      deep: true,
      immediate: true,
    },
    selectedCams: {
      handler: function (val) {
        this.checkAllSelected();
        this.isChanged = this.checkAnyChange(val);
      },
      deep: true,
    },
  },
  created() {
    this.currentCategory = 3;
  },
  mounted() {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
  methods: {
    ...mapActions('settings', [
      'setCurrentSelectedCamsGroup',
      'updateCameraGroup',
    ]),
    mapRows(items) {
      return items.filter((item) => +item.id !== AllCamerasIdGroup);
    },
    checkAllSelected() {
      this.allSelected =
        Object.values(this.selectedCams).filter((s) => s).length ===
        this.tableItems.length;
    },
    checkAnyChange(selectedCams) {
      const a = Object.keys(selectedCams).filter((key) => selectedCams[key]);
      const b = Object.keys(this.oldSelectedCams).filter(
        (key) => this.oldSelectedCams[key]
      );
      const diff =
        a.length > b.length
          ? a.filter((e) => !b.includes(e))
          : b.filter((e) => !a.includes(e));
      return diff.length > 0;
    },
    async handleSubmit() {
      const authList = Object.keys(this.selectedCams)
        .filter(
          (key) => this.selectedCams[key] && Number(key) !== AllCamerasIdGroup
        )
        .map((key) => {
          return {
            camera_group_id: Number(key),
            camera_group_name: this.groupCams.find(
              (cam) => cam.id === Number(key)
            ).title,
            authority: this.camSelectValue[key],
          };
        });
      this.$emit('onSubmit', { authList, email: this.email });
    },
    handleSelect(selected, id) {
      if (!selected) {
        this.$set(this.camSelectValue, id, null);
      } else {
        this.$set(
          this.camSelectValue,
          id,
          this.authorityItems.find((a) => a.canOperate).value
        );
      }
    },
    handleSelectAll(selected) {
      this.groupCams.forEach((cam) => {
        //not already selected
        if (!this.selectedCams[cam.id] && selected) {
          this.$set(
            this.camSelectValue,
            cam.id,
            this.authorityItems.find((a) => a.canOperate).value
          );
        }
        if (!selected) {
          this.$set(this.camSelectValue, cam.id, null);
        }
        this.$set(this.selectedCams, cam.id, selected);
      });
    },
    navigateTo(to) {
      this.$router.push(to);
    },
  },
};
</script>

<style lang="scss">
.editUsers {
  &_select-all {
    margin-right: 10px;

    &-text {
      font-family: 'Noto Sans JP', sans-serif;
      font-size: 12px;
      font-weight: bold;
      color: #4b4b4b;
    }
  }
  &_item-name {
    font-weight: 500;
  }
  &_check {
    width: 267px;
    .v-text-field--outlined > .v-input__control > .v-input__slot {
      min-height: 40px;
    }
    .v-select.v-text-field--outlined:not(.v-text-field--single-line)
      .v-select__selections {
      padding: 0;
    }
    .v-text-field .v-input__append-inner {
      margin-top: 8px;
    }
  }
  &_display {
    margin-left: 12px;
    &.theme--light.v-btn.v-btn--has-bg {
      width: 115px;
      height: 23px;
      border-radius: 5px;
      background-color: #dbe2f3;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.08;
      letter-spacing: normal;
      text-align: left;
      color: #0075c2;
      box-shadow: none;
    }
    &--inactive {
      &.theme--light.v-btn.v-btn--has-bg {
        border-radius: 5px;
        border: solid 1px #ccc;
        background-color: rgba(255, 255, 255, 0);
        color: #989898;
      }
    }
  }
  &_actions {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    &-edit {
      display: flex;
    }
  }
  &_submit {
    margin-top: 30px;

    &.theme--light.v-btn.v-btn--has-bg {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.14;
      letter-spacing: normal;
      text-align: left;
      border-radius: 5px;
      height: 36px;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.16);
      background-color: #0075c2;
      color: #fff;
    }
    &:disabled {
      color: #ccc;
      background-color: #f3f3f3;
    }
  }
  &_save {
    &.theme--light.v-btn.v-btn--has-bg {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.14;
      letter-spacing: normal;
      text-align: left;
      border-radius: 5px;
      width: 120px;
      height: 36px;
      background-color: #0075c2;
      color: #fff;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.16);
    }
    &:disabled {
      color: #ccc;
      background-color: #f3f3f3;
    }
  }
  &_cancel {
    &.theme--light.v-btn.v-btn--has-bg {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: center;
      width: 120px;
      height: 36px;
      background-color: #fff;
      color: #989898;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.16);
    }
    &:disabled {
      color: #ccc;
      background-color: #f3f3f3;
    }
  }
  &_header-name {
    max-width: 250px;
  }
  &_search {
    margin-bottom: 0;
    margin-top: 0;
    padding-top: 0;
    max-width: 327px;
    &.v-input {
      font-size: 18px;
      .v-messages:not(.error--text) {
        .v-messages__message {
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: normal;
          text-align: left;
        }
      }
    }
    .v-text-field__slot {
      padding-left: 0;
    }

    .v-input__slot {
      min-height: 36px !important;
      margin-bottom: 2px;
      .v-input__append-inner {
        margin-top: 9px;
      }
      .v-message__message {
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #989898;
      }
    }
    &.theme--light.v-input input {
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.38;
      letter-spacing: normal;
      text-align: left;
      &:-webkit-autofill,
      &:-webkit-autofill::first-line {
        font-family: 'Noto Sans JP', sans-serif;
        font-size: 16px;
        font-weight: normal;
      }
    }

    .v-text-field__details {
      padding: 0 !important;
      padding-top: 0px !important;
      margin-bottom: 0 !important;
    }
  }
  &-infinit_scroll {
    text-align: center;
  }
  &_event {
    &-label {
      margin-right: 5px;
      padding: 0 !important;
    }
  }
  &.theme--light.v-sheet {
    border-radius: 0;
    box-shadow: none;
    padding: 0;
  }
  &_gap-header {
    height: 26px;
  }
  &_select {
    &-icon {
      width: 34px;
      height: 34px;
      padding: 5px 5px 5px 5px;
      background-color: #0075c2;
      border-radius: 50%;
      display: table-cell;
      vertical-align: middle;
      text-align: center;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      .icon-check {
        color: #fff;
        font-size: 25px;
        font-weight: 900;
      }
    }
  }
  &_tbl {
    td {
      vertical-align: middle;
      max-width: 75px;
      padding-top: 10px !important;
      padding-bottom: 10px !important;
      .v-select__selection.v-select__selection--comma {
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.38;
        letter-spacing: normal;
        text-align: left;
        color: #4b4b4b;
      }
    }
    th {
      vertical-align: middle;
      min-width: 130px;
      & > span {
        font-family: 'Noto Sans JP', sans-serif;
        font-size: 12px;
        font-weight: bold;
        color: #4b4b4b;
      }
    }
    &-header {
      &--name {
        display: flex;
        align-items: center;
        & > span {
          font-family: 'Noto Sans JP', sans-serif;
          font-size: 12px;
          font-weight: bold;
          color: #4b4b4b;
        }
      }
    }
    &.v-data-table {
      margin-top: 15px;
    }
    &-name {
      max-width: 100%;
      display: flex;
      align-items: center;
      & > .videoStream {
        max-width: 100px;
        margin-right: 10px;
      }
      & > .customCheck {
        margin-right: 10px;
      }
    }
    &-registerd,
    &-account {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      color: #4b4b4b;
    }
  }

  tr {
    cursor: pointer;
    &.selected {
      background-color: #f4f6fc !important;
      border-color: #f4f6fc !important;
    }
  }
  &_btn {
    margin-right: 5px;
  }
  display: flex;
  flex-direction: column;
  &_subtitle {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;
    color: #989898;
  }
  &_title {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #666;
  }
  &_videos {
    position: relative;
  }
  .v-btn {
    &:not(.v-btn--round).v-size--x-small {
      padding-left: 8px;
      padding-right: 8px;
      &.v-btn--outlined {
        padding-left: 7px;
        padding-right: 7px;
        color: #989898;
        border-color: #989898;
      }
    }
    &:not(:last-child) {
      margin-right: 8px;
    }
  }
  & .v-skeleton-loader {
    margin-top: 10px;
  }
  & .v-skeleton-loader__table-heading,
  & .v-skeleton-loader__table-tfoot {
    display: none;
  }
  &_name {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: #666;
    margin-bottom: 10px;
    height: 20px;
    display: block;
  }
  &_note {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: right;
    color: #eb545b;
  }
  &_input {
    &-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 345px;
    }
    &-name {
      max-width: 345px;
      &.theme--light.v-input {
        input {
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.38;
          letter-spacing: normal;
          text-align: left;
          color: #4b4b4b;
        }
        .v-text-field__details {
          padding: 0 8px 0 0;
          .v-messages.theme--light:not(.error--text) {
            .v-messages__message {
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              letter-spacing: normal;
              text-align: left;
              color: #989898;
            }
          }
        }
      }
    }
    &-email {
      &.theme--light.v-input {
        .v-text-field__details {
          padding: 8px 0 15px 0;
          .v-messages.theme--light:not(.error--text) {
            .v-messages__message {
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              letter-spacing: normal;
              text-align: left;
              color: #989898;
            }
          }
        }
      }
    }
  }
}
</style>
